
<!-- ToDo: usar componente shared modal, que sirve para inyectar contenido en modales -->
<!-- llamas al componente y creas el template -->
<!-- este componente sirve para mostrar el mensaje de "contraseña actualizada" -->  

<aig-modal class="aig-modal-message" position="center" customMaxWidth="400px">
    <div class="u-p-8 u-pb-3" body>
      <div class="p-flexcc u-dir-col">
        <img src="./assets/images/logos/logo.svg" class="u-mb-3" />
    
        <p class="u-fs-18 u-fw-400 u-color-black u-mt-def">La contraseña ha sido actualizada correctamente, ya puedes iniciar sesión.</p>
      </div>
    </div>
    <div class="u-px-def u-pt-0 u-pb-7" buttons> 
      <button
      class="aig-message__btn e-btn--primary p-flexcc"
      (click)="clickHide()">Aceptar
    </button>
    </div>
  </aig-modal>
